var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12H4C4 13.9167 4.60417 15.6083 5.8125 17.075C7.02083 18.5417 8.56667 19.4667 10.45 19.85L9 18.4L10.4 17L14.95 21.55C14.4667 21.7167 13.9792 21.8333 13.4875 21.9C12.9958 21.9667 12.5 22 12 22ZM12.5 15V9H15.5C15.7833 9 16.0208 9.09583 16.2125 9.2875C16.4042 9.47917 16.5 9.71667 16.5 10V14C16.5 14.2833 16.4042 14.5208 16.2125 14.7125C16.0208 14.9042 15.7833 15 15.5 15H12.5ZM7.5 15V13.5H10V12.5H8.5V11.5H10V10.5H7.5V9H10.5C10.7833 9 11.0208 9.09583 11.2125 9.2875C11.4042 9.47917 11.5 9.71667 11.5 10V14C11.5 14.2833 11.4042 14.5208 11.2125 14.7125C11.0208 14.9042 10.7833 15 10.5 15H7.5ZM14 13.5H15V10.5H14V13.5ZM20 12C20 10.0833 19.3958 8.39167 18.1875 6.925C16.9792 5.45833 15.4333 4.53333 13.55 4.15L15 5.6L13.6 7L9.05 2.45C9.53333 2.28333 10.0208 2.16667 10.5125 2.1C11.0042 2.03333 11.5 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12H20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3D);
export default __webpack_public_path__ + "static/media/icon-3d.bad3a9f2e983b81633c4397bbd6a149e.svg";
export { ForwardRef as ReactComponent };